// import React, { useEffect, Profiler, useState } from 'react'
// // import ReactPWAInstallProvider, { useReactPWAInstall } from "react-pwa-install";
// import './Component-css/Downloadbutton.css?v=0.1'
// // let deferredPrompt;
// const Downloadbutton = () => {
//   const [supportsPWA, setSupportsPWA] = useState(false)
//   const [promptInstall, setPromptInstall] = useState(null)

//   useEffect(() => {
//     const handler = e => {
//       e.preventDefault()
//       console.log('we are being triggered :D')
//       setSupportsPWA(true)
//       setPromptInstall(e)
//     }
//     window.addEventListener('beforeinstallprompt', handler)

//     return () => window.removeEventListener('transitionend', handler)
//   }, [])

//   const onClick = evt => {
//     evt.preventDefault()
//     if (!promptInstall) {
//       return
//     }
//     promptInstall.prompt()
//   }
//   if (!supportsPWA) {
//     return null
//   }

//   return (
//     <div
//       className='my-stickey-footer'
//       style={{
//         position: 'fixed',
//         bottom: 0,
//         width: '100%',
//         maxWidth: 480,
//         backgroundColor: '#112436'
//       }}
//     >
//         <button
//           onClick={onClick}
//           className='btn btn-success btn-sm download_app_btn'
//           style={{ fontWeight: 500 }}
//         >
//           <img
//             src='https://khelbro.com/images/android.png'
//             alt=''
//             style={{ marginRight: 10 }}
//             width='15px'
//           />
//           <span> DOWNLOAD OUR APP</span>
//           <img
//             src='https://khelbro.com/images/dowloadIcon.png'
//             alt=''
//             style={{ marginLeft: 10 }}
//             width='13px'
//           />
//         </button>
//       </div>
//   )
// }

// export default Downloadbutton


import React, { useEffect, useState } from "react";

const DownloadPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setSupportsPWA(true);
      setPromptInstall(e);
      setShowPopup(true); // show popup when PWA prompt is available
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = (e) => {
    e.preventDefault();
    if (!promptInstall) return;
    promptInstall.prompt();
  };

  if (!supportsPWA || !showPopup) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <button className="close-btn" onClick={() => setShowPopup(false)}>
          ✕
        </button>
        <img
          src="/images/addanew.png"
          alt="App Logo"
          className="popup-logo"
        />
        <h3 className="popup-title">Download Our App</h3>
        <button className="download-btn" onClick={handleInstall}>
          DOWNLOAD APP <img src="/images/dowloadIcon.png" alt="" />
        </button>
      </div>
    </div>
  );
};

export default DownloadPopup;
